import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg
    id="Group_707"
    data-name="Group 707"
    viewBox="0 0 255.947 257.793"
    ref={svgRef}
    {...props}
  >
    <title>
      Generic paper and user icon
    </title>
    <defs>
      <style>
        {`.cls-1{fill:#d9d9d6}.cls-2{fill:#f2f2f2}.cls-3{fill:#a7a8aa}`}
      </style>
      <clipPath id="person-clip-path">
        <circle id="" cx={27} cy={44} r={64} />
      </clipPath>
    </defs>
    <g id="gray-paper-with-shadow" data-name="Group 704">
      <path
        id="Path_241"
        data-name="Path 241"
        className="cls-1"
        d="M6.1 21.916v224.316h176.08V6.1h-160z"
        transform="translate(9.979 9.979)"
      />
      <g id="Group_703" data-name="Group 703">
        <path
          id="Path_242"
          data-name="Path 242"
          className="cls-2"
          d="M0 47.974v192.158h176.08V0H47.974z"
        />
        <path
          id="Rectangle_325"
          data-name="Rectangle 325"
          className="cls-3 gray-text"
          transform="translate(27.941 100.165)"
          d="M0 0h120.198v7.908H0z"
        />
        <path
          id="Rectangle_326"
          data-name="Rectangle 326"
          className="cls-3 gray-text"
          transform="translate(27.941 124.152)"
          d="M0 0h120.198v7.908H0z"
        />
        <path
          id="Rectangle_327"
          data-name="Rectangle 327"
          className="cls-3 gray-text"
          transform="translate(27.941 148.139)"
          d="M0 0h120.198v7.908H0z"
        />
        <path
          id="Rectangle_328"
          data-name="Rectangle 328"
          className="cls-3 gray-text"
          transform="translate(27.941 172.126)"
          d="M0 0h120.198v7.908H0z"
        />
        <path
          id="Rectangle_329"
          data-name="Rectangle 329"
          className="cls-3 gray-text"
          transform="translate(27.941 196.113)"
          d="M0 0h56.145v7.908H0z"
        />
        <path
          id="Path_243"
          data-name="Path 243"
          className="cls-1"
          d="M47.974 0v47.974H0z"
        />
      </g>
    </g>
    <g>
      <g
        id="Group_705"
        data-name="Group 705"
        transform="translate(127.842 129.687)"
      >
        <circle
          id="blue-dot"
          data-name="Ellipse 32"
          cx={64.053}
          cy={64.053}
          r={64.053}
          fill="#0090da"
        />
      </g>
      <g
        id="person"
        data-name="Group 706"
        transform="translate(165.536 150.775)"
        clipPath="url(#person-clip-path)"
      >
        <circle
          id="persons-head"
          data-name="Ellipse 33"
          className="cls-2"
          cx={26.359}
          cy={26.359}
          r={26.359}
        />
        <path
        id="persons-body"
        data-name="Path 244"
        d="M101.592 128.392a63.09 63.09 0 0 0 46.656-20.56 228.473 228.473 0 0 0-9.489-28.732h-74.07a225.167 225.167 0 0 0-9.489 28.468 61.384 61.384 0 0 0 46.392 20.824z"
        // transform="translate(90.303 129.401)"
        transform="translate(-75.233 -21.374)"
        fill="#a4ce4c"
      />
      </g>
      
    </g>
  </svg>
)

const ClaimProcessSVG = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))

export default ClaimProcessSVG
